(ns shared.core.debug.data
  (:require [shared.core.reactive :as re]
            [shared.core.config :as config]
            [cljs.reader :refer [read-string]]
            [clojure.string :as s]
            [shared.core.util :as util]))

(def root-path (util/ns->keyword-path ::root))

(defn debug-toolbar? [db]
  (get-in db (conj root-path :toolbar?)))

(re/reg-event-db
  :debug/set-app-rerender-on-load re/middleware
  (fn [db [rerender?]]
    (assoc-in db (conj root-path :app-rerender-on-load?) rerender?)))

(re/reg-sub
  :debug/app-rerender-on-load?
  (fn [db]
    (get-in db (conj root-path :app-rerender-on-load?) true)))

(re/reg-sub :debug/toolbar?- debug-toolbar?)

(re/reg-event-db
  :debug/toggle-toolbar re/middleware
  (fn [db]
    (assoc-in db (conj root-path :toolbar?) (not (debug-toolbar? db)))))

(re/reg-sub
  :debug/app-db-search-results-
  (fn [db]
    (if-let [search-path (get-in db (conj root-path :app-db-search))]
      (or (cond
            (s/starts-with? search-path "[")
            (get-in db (read-string search-path))

            (s/includes? search-path ".")
            (get-in db (util/ns->keyword-path (keyword (str search-path "/root"))))

            :else
            (some->> (s/split search-path #" ")
                     (map read-string)
                     (get-in db)))
          "No Results Found")
      db)))

(re/reg-sub
  :debug/search-
  (fn [db]
    (get-in db (conj root-path :search))))

(re/reg-sub
  :debug/re-frame-event-
  (fn [db]
    (get-in db (conj root-path :re-frame-event))))

(re/reg-event-db
  :debug/search-app-db re/middleware
  (fn [db [path]]
    (assoc-in db (conj root-path :app-db-search) (if (s/blank? path) " " path))))

(re/reg-event-db
  :debug/dispatch-event re/middleware
  (fn [db [evt]]
    (when evt
      (re/dispatch (read-string (str (when-not (s/starts-with? evt "[")
                                       "[")
                                     evt
                                     (when-not (s/ends-with? evt "[")
                                       "]")))))
    db))

(re/reg-sub
  :debug/event-logs?-
  (fn [db]
    (get-in db (conj root-path :event-logs?))))

(re/reg-event-db
  :debug/toggle-event-logs re/middleware
  (fn [db]
    (let [new-v (not (get-in db (conj root-path :event-logs?)))]
      (config/set-debug new-v)
      (assoc-in db (conj root-path :event-logs?) new-v))))

(re/reg-event-db
  :debug/initialize-event-logs re/middleware
  (fn [db]
    (assoc-in db (conj root-path :event-logs?) @config/debug?*)))

(re/reg-event-db
  :debug/init-react-error re/middleware
  (fn [db]
    (assoc-in db (conj root-path :test-error :value) nil)))

(re/reg-sub
  :debug/test-react-error-
  (fn [db]
    (when-let [test-error (get-in db (conj root-path :test-error))]
      (-> test-error :value (s/lower-case)))))
